<img class="card-image" [src]="imageUrl" *ngIf="imageUrl" [alt]="primaryText || secondaryText" />

<div class="card-content column">
  <h2 class="flex-1 text-truncate" zen-translate *ngIf="primaryText">{{ primaryText }}</h2>
  <p class="light text-truncate" zen-translate *ngIf="secondaryText">{{ secondaryText }}</p>
</div>
